import { EmergencyPhase, IncidentStatus, type SearchIncidentsFilter } from "@/models"
import { RefQueries, useQueryStoreRef } from "vue-utils"

export function bindIncidentsFilterToQuery(filter: SearchIncidentsFilter) {
	useQueryStoreRef("year", filter, "year", RefQueries.NullableInt)
	useQueryStoreRef("status", filter, "statuses", RefQueries.arrayOf(RefQueries.enum(IncidentStatus)))
	useQueryStoreRef("type", filter, "incidentTypeIds", RefQueries.arrayOf(RefQueries.Int))
	useQueryStoreRef("phase", filter, "emergencyPhases", RefQueries.arrayOf(RefQueries.enum(EmergencyPhase)))
}
